import { Grid } from '@chipinside/frontend'
import { Box, Divider } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledGroupRow = styled(Grid)(({ theme }) => ({
  '&:empty': {
    display: 'none',
  },
  'borderLeft': `3px solid ${theme.palette.divider}`,
  'paddingBottom': theme.spacing(2),
  'paddingLeft': theme.spacing(3),
  'paddingRight': theme.spacing(5),
  'paddingTop': theme.spacing(2),
}))

const FormbuilderGroupRow = ({ lineNumber, lines, ...rest }: any) => {
  return (
    <Box sx={{ my: 2 }}>
      <StyledGroupRow {...rest} mb={2} />
      {lines > 1 && lineNumber < lines - 1 && <Divider />}
    </Box>
  )
}
export { FormbuilderGroupRow }
